// Shared actions are hidden for now: the Actions side menu tab and the
// "Share Actions access" item in the header menu. The feature still works
// at /actions/shared-actions. Set to true to show both again.
export const SHARED_ACTIONS_VISIBLE = false;
